import React from 'react';
import PropTypes from 'prop-types';

function Image({ alt, endpoint, src, ...restProps }) {
  return <img alt={alt} src={`${endpoint}/${src}`} {...restProps} />;
}

Image.propTypes = {
  endpoint: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

Image.defaultProps = {
  endpoint: process.env.REACT_APP_OSS_ROOT,
  alt: '',
};
export default Image;
